/** 고객센터 /support/faq용 — 랜딩 FAQ보다 넓게 */
export const publicFaqExtendedItems = [
  {
    question: '개인 설계사도 써볼 수 있나요?',
    answer: '네. 가입 절차를 거치면 개인 회원으로도 이용할 수 있어요. 조직으로 도입하면 조직 전용 기능도 함께 이용할 수 있어요.',
  },
  {
    question: '앱이에요, 웹이에요?',
    answer: '둘 다 있어요. 일부 복잡한 설정만 웹에서 제공하고, 나머지 기능은 앱과 웹에서 모두 이용할 수 있어요.',
  },
  {
    question: '도입·이용 문의는 어디로 하면 되나요?',
    answer: '도입 문의 페이지에서 문의 양식을 제출해 주세요. 접수되면 연락드릴게요.',
  },
  {
    question: '구독 시작 후 고객문의는 어떻게 하나요?',
    answer: '로그인한 계정은 웹 메뉴의 고객문의를 이용할 수 있어요. 기본적으로 비공개로 문의가 이루어져요.',
  },
  {
    question: '진료정보분석·건축물대장 기능은 누가 쓰나요?',
    answer: '현장에서 상담·분석하시는 분들이 주로 활용하시고, 정리된 내용은 설계 의뢰로 이어질 수 있어요. 세부 범위는 계약·역할에 따라 달라질 수 있어요.',
  },
  {
    question: '요금은 어떻게 알 수 있나요?',
    answer: '이용 형태(개인/조직)·규모에 따라 달라질 수 있어요. 요금 안내 페이지를 참고하시고, 확정이 필요하면 문의로 남겨 주세요.',
  },
  {
    question: '결제·구매는 어디서 하나요?',
    answer: '현재 개인의 구독은 앱에서 결제 가능합니다. 조직 도입의 경우는 별도로 문의해주세요.',
  },
  {
    question: '앱은 스토어에서 바로 받나요?',
    answer: '앱은 각 스토어(앱스토어/플레이스토어) 에서 다운로드 가능합니다. PC는 바로 접속 가능해요!',
  },
]
